import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/lms/microlearnings")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
